import React, {PureComponent} from 'react';
import EditBar from "./EditBar"
import WeeklyChallengeList from './WeeklyChallengeList';
import RecentAchievements from "./Achievements/RecentAchievements";
import ListContainer from "./ListView/ListContainer";
import Spinner from "~/components/Spinner";
import EditProfile from "./EditProfile";
import connect from "~/tools/connect"
import profileStore from '~/redux/profile/store'
import userStore from '~/redux/user/store';
import "./style.scss";
import {getProfile, updateEditing} from "~/redux/profile/actions"
import _ from 'lodash'

const navigateToAll = () =>
{
    console.log('All');
}

class ViewNeoProfile extends PureComponent {

    constructor(props){
        super(props);
    }

    componentDidMount()
    {
        this.props.layout.loginPath = 'home';
        if(!this.state.user && this.props.layout.loginPath){
            window.location.href = `/${this.props.layout.loginPath}`;
        }
        const userId = this.state.user.userId;

        profileStore.dispatch(
            getProfile(userId)
        )
        let search = new URLSearchParams(window.location.search);
        
        if(search.has('profile') === true)
        {
            profileStore.dispatch(updateEditing(true))
        }
    }

    changeMode = e => {
        profileStore.dispatch(
            updateEditing(!this.state.editing)
        )
    }
    render()
    {
        let {main:profile, achievements} = this.state.profile.data;
        if(!profile){
            _.set(this.state.profile.data, 'main', this.state.profile.data.profile)
            profile = this.state.profile.data.main
        }
            
        const loading  = this.state.profile.loading;
        const { errors, saving, questions} = this.state;
        const weeklyChallenges = achievements ? achievements.filter(e=>e.type==="weekly") : [];
        weeklyChallenges.length > 0 && console.log(weeklyChallenges[0].completion)

        if(loading)
        {
            return <div className="neoProfileContainer">
                <Spinner/>
            </div>
        }

        if(this.state.editing)
        {
            return <EditProfile questions={questions} errors={errors} saving={saving} profile={profile} user={this.state.user} />
        }

        return <div className="neoProfileContainer">
            <div className="left">
                <EditBar profile={profile} onEdit={this.changeMode}/>
                {/* <WeeklyChallengeList challenges={weeklyChallenges.length > 0 ? weeklyChallenges[0].completion : []}/> */}
            </div>
            <div className="right">
                {/* <RecentAchievements achievements={achievements} navigateToAll={navigateToAll} /> */}
                <ListContainer/>
            </div>
        </div>
    }
}

connect(ViewNeoProfile, state => ({ user: state.user }), userStore)
connect(ViewNeoProfile, state => ({ 
    profile: state.profile,
    editing: state.editing,
    saving: state.saving,
    errors: state.errors,
    questions: state.questions
}), profileStore)

export default ViewNeoProfile;
